import { render } from "./LikeIcon01.vue?vue&type=template&id=01249c80&scoped=true"
import script from "./LikeIcon01.vue?vue&type=script&lang=js"
export * from "./LikeIcon01.vue?vue&type=script&lang=js"

import "./LikeIcon01.vue?vue&type=style&index=0&id=01249c80&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01249c80"]])

export default __exports__